import cn from 'classnames';

import {CrossIcon} from '../icons/CrossIcon';

import s from './ModalBackButton.module.css';

interface Props {
  onClick: VoidFunction;
  className?: string;
}

export function ModalBackButton({onClick, className}: Props): JSX.Element {
  return (
    <button onClick={onClick} className={cn(s.root, className)}>
      <CrossIcon />
    </button>
  );
}
